/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AutomationBody,
  AutomationDetailOutputBody,
  AutomationInputBody,
  AutomationsOutputBody,
  AutomationsUpdateHeaders,
  ErrorModel,
  TestAutomationInputBody,
  TestAutomationOutputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type automationsDeleteResponse204 = {
  data: void
  status: 204
}

export type automationsDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsDeleteResponseSuccess = (automationsDeleteResponse204) & {
  headers: Headers;
};
export type automationsDeleteResponseError = (automationsDeleteResponse401 | automationsDeleteResponse403 | automationsDeleteResponse404 | automationsDeleteResponse422 | automationsDeleteResponse500) & {
  headers: Headers;
};

export type automationsDeleteResponse = (automationsDeleteResponseSuccess | automationsDeleteResponseError)

export const getAutomationsDeleteUrl = (automationId: string,) => {




  return `/automations/${automationId}`
}

/**
 * @summary Удалить автоматизацию
 */
export const automationsDelete = async (automationId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<automationsDeleteResponse> => {

  return facetaFetch<automationsDeleteResponse>(getAutomationsDeleteUrl(automationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAutomationsDeleteQueryKey = (automationId: string,) => {
    return [
    'DELETE', `/automations/${automationId}`
    ] as const;
    }


export const getAutomationsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof automationsDelete>>, TError = ErrorModel>(automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsDeleteQueryKey(automationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsDelete>>> = ({ signal }) => automationsDelete(automationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: automationId !== null && automationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof automationsDelete>>>
export type AutomationsDeleteQueryError = ErrorModel


export function useAutomationsDelete<TData = Awaited<ReturnType<typeof automationsDelete>>, TError = ErrorModel>(
 automationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsDelete>>,
          TError,
          Awaited<ReturnType<typeof automationsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsDelete<TData = Awaited<ReturnType<typeof automationsDelete>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsDelete>>,
          TError,
          Awaited<ReturnType<typeof automationsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsDelete<TData = Awaited<ReturnType<typeof automationsDelete>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить автоматизацию
 */

export function useAutomationsDelete<TData = Awaited<ReturnType<typeof automationsDelete>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsDeleteQueryOptions(automationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type automationsGetResponse200 = {
  data: AutomationDetailOutputBody
  status: 200
}

export type automationsGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsGetResponseSuccess = (automationsGetResponse200) & {
  headers: Headers;
};
export type automationsGetResponseError = (automationsGetResponse401 | automationsGetResponse403 | automationsGetResponse404 | automationsGetResponse422 | automationsGetResponse500) & {
  headers: Headers;
};

export type automationsGetResponse = (automationsGetResponseSuccess | automationsGetResponseError)

export const getAutomationsGetUrl = (automationId: string,) => {




  return `/automations/${automationId}`
}

/**
 * @summary Автоматизация и журнал запусков
 */
export const automationsGet = async (automationId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<automationsGetResponse> => {

  return facetaFetch<automationsGetResponse>(getAutomationsGetUrl(automationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutomationsGetQueryKey = (automationId: string,) => {
    return [
    `/automations/${automationId}`
    ] as const;
    }


export const getAutomationsGetQueryOptions = <TData = Awaited<ReturnType<typeof automationsGet>>, TError = ErrorModel>(automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsGetQueryKey(automationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsGet>>> = ({ signal }) => automationsGet(automationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: automationId !== null && automationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof automationsGet>>>
export type AutomationsGetQueryError = ErrorModel


export function useAutomationsGet<TData = Awaited<ReturnType<typeof automationsGet>>, TError = ErrorModel>(
 automationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsGet>>,
          TError,
          Awaited<ReturnType<typeof automationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsGet<TData = Awaited<ReturnType<typeof automationsGet>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsGet>>,
          TError,
          Awaited<ReturnType<typeof automationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsGet<TData = Awaited<ReturnType<typeof automationsGet>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Автоматизация и журнал запусков
 */

export function useAutomationsGet<TData = Awaited<ReturnType<typeof automationsGet>>, TError = ErrorModel>(
 automationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsGetQueryOptions(automationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type automationsUpdateResponse200 = {
  data: AutomationBody
  status: 200
}

export type automationsUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsUpdateResponse412 = {
  data: ErrorModel
  status: 412
}

export type automationsUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsUpdateResponseSuccess = (automationsUpdateResponse200) & {
  headers: Headers;
};
export type automationsUpdateResponseError = (automationsUpdateResponse401 | automationsUpdateResponse403 | automationsUpdateResponse404 | automationsUpdateResponse412 | automationsUpdateResponse422 | automationsUpdateResponse500) & {
  headers: Headers;
};

export type automationsUpdateResponse = (automationsUpdateResponseSuccess | automationsUpdateResponseError)

export const getAutomationsUpdateUrl = (automationId: string,) => {




  return `/automations/${automationId}`
}

/**
 * Целиком. Пустой токен бота или ключ подписи — прежние.
 * @summary Изменить автоматизацию
 */
export const automationsUpdate = async (automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<automationsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<automationsUpdateResponse>(getAutomationsUpdateUrl(automationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(automationInputBody)
  }
);}





export const getAutomationsUpdateQueryKey = (automationId: string,
    automationInputBody?: NonReadonly<AutomationInputBody>,) => {
    return [
    'PUT', `/automations/${automationId}`, automationInputBody
    ] as const;
    }


export const getAutomationsUpdateQueryOptions = <TData = Awaited<ReturnType<typeof automationsUpdate>>, TError = ErrorModel>(automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsUpdateQueryKey(automationId,automationInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsUpdate>>> = ({ signal }) => automationsUpdate(automationId,automationInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: automationId !== null && automationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof automationsUpdate>>>
export type AutomationsUpdateQueryError = ErrorModel


export function useAutomationsUpdate<TData = Awaited<ReturnType<typeof automationsUpdate>>, TError = ErrorModel>(
 automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsUpdate>>,
          TError,
          Awaited<ReturnType<typeof automationsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsUpdate<TData = Awaited<ReturnType<typeof automationsUpdate>>, TError = ErrorModel>(
 automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsUpdate>>,
          TError,
          Awaited<ReturnType<typeof automationsUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsUpdate<TData = Awaited<ReturnType<typeof automationsUpdate>>, TError = ErrorModel>(
 automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить автоматизацию
 */

export function useAutomationsUpdate<TData = Awaited<ReturnType<typeof automationsUpdate>>, TError = ErrorModel>(
 automationId: string,
    automationInputBody: NonReadonly<AutomationInputBody>,
    headers: AutomationsUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsUpdateQueryOptions(automationId,automationInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type automationsTestResponse200 = {
  data: TestAutomationOutputBody
  status: 200
}

export type automationsTestResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsTestResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsTestResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsTestResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsTestResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsTestResponseSuccess = (automationsTestResponse200) & {
  headers: Headers;
};
export type automationsTestResponseError = (automationsTestResponse401 | automationsTestResponse403 | automationsTestResponse404 | automationsTestResponse422 | automationsTestResponse500) & {
  headers: Headers;
};

export type automationsTestResponse = (automationsTestResponseSuccess | automationsTestResponseError)

export const getAutomationsTestUrl = (automationId: string,) => {




  return `/automations/${automationId}/test`
}

/**
 * Выполняет действия сразу — письма и сообщения уходят по-настоящему. Запуск — в журнал.
 * @summary Проверить на записи
 */
export const automationsTest = async (automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<automationsTestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<automationsTestResponse>(getAutomationsTestUrl(automationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testAutomationInputBody)
  }
);}





export const getAutomationsTestQueryKey = (automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>,) => {
    return [
    'POST', `/automations/${automationId}/test`, testAutomationInputBody
    ] as const;
    }


export const getAutomationsTestQueryOptions = <TData = Awaited<ReturnType<typeof automationsTest>>, TError = ErrorModel>(automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsTestQueryKey(automationId,testAutomationInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsTest>>> = ({ signal }) => automationsTest(automationId,testAutomationInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: automationId !== null && automationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsTestQueryResult = NonNullable<Awaited<ReturnType<typeof automationsTest>>>
export type AutomationsTestQueryError = ErrorModel


export function useAutomationsTest<TData = Awaited<ReturnType<typeof automationsTest>>, TError = ErrorModel>(
 automationId: string,
    testAutomationInputBody: undefined |  NonReadonly<TestAutomationInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsTest>>,
          TError,
          Awaited<ReturnType<typeof automationsTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsTest<TData = Awaited<ReturnType<typeof automationsTest>>, TError = ErrorModel>(
 automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsTest>>,
          TError,
          Awaited<ReturnType<typeof automationsTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsTest<TData = Awaited<ReturnType<typeof automationsTest>>, TError = ErrorModel>(
 automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Проверить на записи
 */

export function useAutomationsTest<TData = Awaited<ReturnType<typeof automationsTest>>, TError = ErrorModel>(
 automationId: string,
    testAutomationInputBody?: NonReadonly<TestAutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsTest>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsTestQueryOptions(automationId,testAutomationInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type automationsListResponse200 = {
  data: AutomationsOutputBody
  status: 200
}

export type automationsListResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsListResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsListResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsListResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsListResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsListResponseSuccess = (automationsListResponse200) & {
  headers: Headers;
};
export type automationsListResponseError = (automationsListResponse401 | automationsListResponse403 | automationsListResponse404 | automationsListResponse422 | automationsListResponse500) & {
  headers: Headers;
};

export type automationsListResponse = (automationsListResponseSuccess | automationsListResponseError)

export const getAutomationsListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/automations`
}

/**
 * @summary Автоматизации окружения
 */
export const automationsList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<automationsListResponse> => {

  return facetaFetch<automationsListResponse>(getAutomationsListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutomationsListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/automations`
    ] as const;
    }


export const getAutomationsListQueryOptions = <TData = Awaited<ReturnType<typeof automationsList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsList>>> = ({ signal }) => automationsList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsListQueryResult = NonNullable<Awaited<ReturnType<typeof automationsList>>>
export type AutomationsListQueryError = ErrorModel


export function useAutomationsList<TData = Awaited<ReturnType<typeof automationsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsList>>,
          TError,
          Awaited<ReturnType<typeof automationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsList<TData = Awaited<ReturnType<typeof automationsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsList>>,
          TError,
          Awaited<ReturnType<typeof automationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsList<TData = Awaited<ReturnType<typeof automationsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Автоматизации окружения
 */

export function useAutomationsList<TData = Awaited<ReturnType<typeof automationsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type automationsCreateResponse201 = {
  data: AutomationBody
  status: 201
}

export type automationsCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type automationsCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type automationsCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type automationsCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type automationsCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type automationsCreateResponseSuccess = (automationsCreateResponse201) & {
  headers: Headers;
};
export type automationsCreateResponseError = (automationsCreateResponse401 | automationsCreateResponse403 | automationsCreateResponse404 | automationsCreateResponse422 | automationsCreateResponse500) & {
  headers: Headers;
};

export type automationsCreateResponse = (automationsCreateResponseSuccess | automationsCreateResponseError)

export const getAutomationsCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/automations`
}

/**
 * Событие в коллекции окружения → действия по порядку.
 * @summary Завести автоматизацию
 */
export const automationsCreate = async (id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<automationsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<automationsCreateResponse>(getAutomationsCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(automationInputBody)
  }
);}





export const getAutomationsCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    automationInputBody?: NonReadonly<AutomationInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/automations`, automationInputBody
    ] as const;
    }


export const getAutomationsCreateQueryOptions = <TData = Awaited<ReturnType<typeof automationsCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutomationsCreateQueryKey(id,kind,automationInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof automationsCreate>>> = ({ signal }) => automationsCreate(id,kind,automationInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutomationsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof automationsCreate>>>
export type AutomationsCreateQueryError = ErrorModel


export function useAutomationsCreate<TData = Awaited<ReturnType<typeof automationsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsCreate>>,
          TError,
          Awaited<ReturnType<typeof automationsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsCreate<TData = Awaited<ReturnType<typeof automationsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof automationsCreate>>,
          TError,
          Awaited<ReturnType<typeof automationsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutomationsCreate<TData = Awaited<ReturnType<typeof automationsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести автоматизацию
 */

export function useAutomationsCreate<TData = Awaited<ReturnType<typeof automationsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    automationInputBody: NonReadonly<AutomationInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof automationsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutomationsCreateQueryOptions(id,kind,automationInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






